<template>
  <el-dialog title="分配广告账号" :visible.sync="showDialog" width="720px" :close-on-click-modal="false">
    <div class="forLabel">
      <el-select v-model="platType" style="margin-right: 16px; width: 160px" @change="selectDataList">
        <el-option v-for="item in platTypeList.filter((item) => item.value !== 4)" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <el-transfer
      filterable
      :props="{ key: 'advertiserId', label: 'advertiserName' }"
      :filter-method="filterMethod"
      v-model="transferData.value"
      :titles="['待选广告账号', '已选广告账号']"
      :data="transferData.list"
      class="dialog-wrap"
    ></el-transfer>
    <span slot="footer" class="dialog-footer">
      <el-button @click="showDialog = false">取 消</el-button>
      <el-button type="primary" @click="handlerTransfer">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import userServer from "@/api/userManagement.js";
import { platTypeList } from "@/config/enum.js";
export default {
  props: {},
  data() {
    return {
      showDialog: false,
      platTypeList,
      transferData: {
        list: [],
        value: [],
      },
      platType: "",
      curUserId: null,
    };
  },
  methods: {
    showModal(userId) {
      this.platType = this.platTypeList[0].value;
      this.curUserId = userId;
      this.showDialog = true;
      this.selectDataList();
    },
    selectDataList() {
      this.transferData.list = [];
      this.transferData.value = [];
      userServer
        .getProductAdvertisers({
          userId: this.curUserId,
          platType: this.platType,
        })
        .then((res) => {
          if (res.code === "0000") {
            this.transferData.list = res.productPermissionList;
            this.transferData.value = res.userPermissionList.map((item) => item.advertiserId);
          }
        });
    },
    handlerTransfer() {
      userServer
        .grantUserPermission({
          userId: this.curUserId,
          advertiserIds: this.transferData.value.join(),
          platType: this.platType,
        })
        .then((res) => {
          if (res.code === "0000") {
            this.$message({
              message: "权限分配成功",
              type: "success",
            });
            this.showDialog = false;
          }
        });
    },
    filterMethod(value, option) {
      let searchSrt = value.toLowerCase();
      let dataStr = `${option.advertiserName}-${option.advertiserId}`.toLowerCase();
      return dataStr.includes(searchSrt);
    },
  },
};
</script>

<style lang="less" scoped>
// .dialog-wrap {
//   /deep/ .el-transfer-panel {
//     width: 245px;
//   }
// }
.forLabel {
  margin-bottom: 16px;
  .multiple-select {
    /deep/ .el-tag.el-tag--info:first-child {
      max-width: 80px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
